var site = site || {};
var generic = generic || {};

(function ($) {
  Drupal.behaviors.productMediaV1 = {
    attach: function (context, settings) {
      var $thumbs = $('.product-full__alt-images-thumb', context);
      var $mainImgWrapper = $('.product-full__image', context);
      var $mainImg = $mainImgWrapper.find('.product-full__image--slide').not('.pc-hidden');
      var $slider = $('.product-full__alt-images', context);
      var $playButton = $('.product-full__image__video', context);
      var $altImagesSlider = $('.product-full__alt-images-slider', context);

      if (site.client.isMobile) {
        $mainImgWrapper.slick({
          dots: true
        });
      }

      $thumbs.once().on('click', function () {
        var $activeThumb = $(this);

        $thumbs.removeClass('active');
        $activeThumb.addClass('active');
        $mainImg.removeClass('active');
        $($mainImg[$activeThumb.index()]).addClass('active');
      });

      $playButton.once().on('click', function () {
        var html = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + $(this).data('youtubeid') + '?&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

        generic.overlay.launch({
          content: html
        });
      });

      if (!site.client.isMobile && $slider.find('.product-full__alt-images-thumb').length > 1) {
        $('.product-full__alt-images-slider').addClass('active');
        $slider.slick({
          vertical: true,
          infinite: false,
          slidesToShow: 4
        });

        $altImagesSlider.on('afterChange', function (e, slick, currentSlide) {
          var $thumbnailNext = $altImagesSlider.find('.slick-next');

          if (currentSlide + 1 === slick.slideCount - 4) { // check to see if we the next slide puts the last slide on the bottom.
            $thumbnailNext.attr('disabled', 'disabled');
          } else {
            $thumbnailNext.removeAttr('disabled');
          }
        });
      }
    }
  };
})(jQuery);
